import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import "./AlertBox.css";

class AlertBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false
    };
    this.handleClose = this.handleClose.bind(this);
  }
  handleClose() {
    console.log("EventDetail : handleClose");
    this.props.onClose();
    this.setState({ redirect: true });
  }

  render() {
    return this.state.redirect ? (
      <Redirect to="/" />
    ) : (
      <div className="modal is-active">
      <div onClick={this.closeModal} className="modal-background" onClick={this.handleClose}></div>
      <div className="modal-content">
        <div className="box card event-detail">
          <header className="card-header">
            <h1>{this.props.headline}</h1>
          </header>
          <div className="card-content">
            <div className="content">
              <p>
                {this.props.msg}
              </p>
            </div>
          </div>
          <footer className="card-footer">
              {this.props.children}
          </footer>
        </div>
        </div>
        <button onClick={this.handleClose} className="modal-close is-large" aria-label="close"></button>
      </div>
    );
  }
}

export default AlertBox;



// WEBPACK FOOTER //
// ./src/AlertBox.js